// FileExpander — client-side expand/collapse for diff file bodies (ts-3).
//
// Replaces the server-side `toggle_expand_file` / `expanded_files` MapSet
// in diff_component.ex.
//
// Markup convention:
//   Attach phx-hook="FileExpander" to the diff-main scroll container.
//   Expand trigger: <el data-expand-file="path/to/file.ex">…</el>
//   File body:      <el data-file-body="path/to/file.ex" class="hidden">…</el>

import type { LiveViewHook } from "./types";

export interface FileExpanderState {
  _onClick: (e: Event) => void;
  _expanded: Set<string>;
}

export const FileExpander = {
  mounted(this: LiveViewHook<never> & FileExpanderState) {
    this._expanded = new Set<string>();

    const onClick = (e: Event): void => {
      const btn = (e.target as HTMLElement).closest<HTMLElement>(
        "[data-expand-file]",
      );
      if (!btn) return;
      const path = btn.dataset["expandFile"];
      if (!path) return;
      const body = this.el.querySelector<HTMLElement>(
        '[data-file-body="' + CSS.escape(path) + '"]',
      );
      if (!body) return;
      const nowHidden = body.classList.toggle("hidden");
      if (nowHidden) {
        this._expanded.delete(path);
      } else {
        this._expanded.add(path);
      }
    };
    this.el.addEventListener("click", onClick);
    this._onClick = onClick;
  },

  updated(this: LiveViewHook<never> & FileExpanderState) {
    for (const path of this._expanded) {
      const body = this.el.querySelector<HTMLElement>(
        '[data-file-body="' + CSS.escape(path) + '"]',
      );
      body?.classList.remove("hidden");
    }
  },

  destroyed(this: LiveViewHook<never> & FileExpanderState) {
    this.el.removeEventListener("click", this._onClick as EventListener);
  },
};
